/*
 * Default items that serve as placeholders until data is loaded from the server.
 */
import { MiaPlaza } from "../../Reinforced.Typings";
import { LocalDate, Instant, Duration, LocalDateTime } from '@js-joda/core';

import defaultAvatarTransparentPicture from "theme/flashlessAvatars/transparent_default.png";
import defaultAvatarBackgroundPicture from "theme/flashlessAvatars/default.png";

export const DefaultUrl = "#no-such-anchor";
export const DefaultText = "…";
export const DefaultJSON = "{}";
export const DefaultDateString = LocalDate.now().toString();
export const DefaultInstantString = Instant.now().toString();
export const DefaultDuration = Duration.ZERO.toString();
export const DefaultSubject = MiaPlaza.Model.Subject.Math;
export const DefaultPicture = {
	AspectRatio: "1/1",
	// a transparent pixel
	OriginalUrl: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",
	Sizes: [],
};
export const DefaultPictureSvg = {
	AspectRatio: "1/1",
	// a svg transparent image
	OriginalUrl: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjwvc3ZnPg==",
	Sizes: [],
};
export const DefaultReceiptData = {
	ParentName: DefaultText,
	ParentEmail: DefaultText,
	PaymentDate: DefaultDateString,
	StudentName: DefaultText,
	Amount: DefaultText,
	Product: MiaPlaza.Model.Payments.ProductType.OneMonth,
	PaymentMethodData: {
		Description: DefaultText,
		PaymentMethodType: DefaultText,
	} as MiaPlaza.LO.Payments.Display.IPaymentMethodData,
};
export const DefaultAvatarPictureTransparent = defaultAvatarTransparentPicture;

export const DefaultAvatarPictureWithBackground = defaultAvatarBackgroundPicture;

export const DefaultTime = DefaultText;
export const DefaultLocalDateTime = LocalDateTime.now().toString();

export const DefaultAuthorData: MiaPlaza.Controllers.Shop.IAuthorData = {
	Id: DefaultText,
	Name: DefaultText,
	Avatar: DefaultAvatarPictureTransparent,
	ProfileUrl: DefaultUrl,
	ShopUrl: DefaultUrl,
	HouseUrl: DefaultUrl,
	CastleType: 0,
}

export const DefaultShopDesignItem: MiaPlaza.Controllers.Shop.IDesignedItemData = {
	Author: DefaultAuthorData,
	Price: 0,
	ProductionCost: 0,
	HighestAllowedPrice: 0,
	Thumbnail: DefaultPicture,
	SoldTimes: 0,
	Name: DefaultText,
	Sale: false,
	Item: DefaultText,
	ItemShopType: MiaPlaza.Control.Games.Shop.PublicShopType.Furniture
};

export const DefaultShapeData: MiaPlaza.Controllers.Shop.IShapeData = {
	Shape: DefaultUrl,
};

export const DefaultPurchaseStatistics = {
	PurchaseCount: [],
	FirstSubscriptionDate: DefaultDateString,
	LatestPurchaseDate: DefaultDateString,
};

export const DefaultFriendship: MiaPlaza.Control.Vue.Vuex.IFriendship = {
	CanBecomeFriend: false,
	IsFriend: false,
	IsPending: false,
	RequestRegularFriendUrl: DefaultUrl,
};

export const DefaultFriendRequest: MiaPlaza.Control.Vue.Lists.IFriendRequest = {
	AcceptUrl: DefaultUrl,
	Avatar: DefaultPicture,
	BlockUrl: DefaultUrl,
	DeclineUrl: DefaultUrl,
	MemberUrl: DefaultUrl,
	Name: DefaultText,
};

export const DefaultMember: MiaPlaza.Control.Vue.Lists.IMember = {
	AvatarSettings: DefaultJSON,
	Birthdate: DefaultTime,
	Description: DefaultText,
	Name: DefaultText,
	Picture: DefaultPicture,
	ProfileLink: DefaultUrl,
};

export const DefaultMemberProfileData: MiaPlaza.Controllers.Members.IMemberProfileData = {
	Name: DefaultText,
	Picture: DefaultPicture,
	ProfileLink: DefaultUrl,
}

export const DefaultMessage: MiaPlaza.Control.Vue.Lists.IMessage = {
	DeleteUrl: DefaultUrl,
	DisplayReplyTo: false,
	IsNew: false,
	IsUnread: false,
	MailboxType: MiaPlaza.Content.MessageListType.ReceivedYouOnly,
	MemberAvatar: DefaultPicture,
	MemberName: DefaultText,
	MemberUrl: DefaultUrl,
	MessageReadUrl: DefaultUrl,
	ReplyUrl: DefaultUrl,
	Subject: DefaultText,
	Text: DefaultText,
	Timestamp: DefaultTime,
	IsStarred: false,
	ToggleIsStarredUrl: DefaultUrl,
};

export const DefaultGiveGift: MiaPlaza.Control.Vue.Lists.IGift = {
	Image: DefaultPicture,
	Link: DefaultUrl,
};

export const DefaultGuestBookEntry: MiaPlaza.Control.Vue.Lists.IGuestBookEntry = {
	AuthorAvatar: DefaultPicture,
	AuthorName: DefaultText,
	AuthorUrl: DefaultUrl,
	CreationDate: DefaultTime,
	DeleteUrl: null,
	Text: DefaultText,
};

export const DefaultAdminMember: MiaPlaza.Control.Vue.Lists.IAdminMember = {
	DetailsUrl: DefaultUrl,
	Id: DefaultText,
	Name: DefaultText,
	Type: MiaPlaza.Model.PortalType.Parents,
};

export const DefaultArticle: MiaPlaza.Control.Vue.Lists.IArticle = {
	Category: DefaultText,
	NewspaperImage: DefaultPicture,
	NewspaperUrl: DefaultUrl,
	PublishingDate: DefaultTime,
	Title: DefaultText,
	TitleUrl: DefaultUrl,
};

export const DefaultBozoMember: MiaPlaza.LO.Members.BozoMember.Models.IBozoMemberData = {
	Name: DefaultText,
	Id: DefaultText,
	AccountDetailsLink: DefaultUrl,
	ReviewerName: DefaultText,
	CreationDate: DefaultText,
	MemberState: 1,
};

export const DefaultLandingPageSubjectData: MiaPlaza.Controllers.Public.ISubjectData = {
	Subject: DefaultSubject,
	Units: [],
	Video: {
		VideoSrc: DefaultUrl,
		ThumbnailSrc: DefaultUrl,
	}
};

export const DefaultInventory: MiaPlaza.Control.Vue.Lists.InventoryItem = {
	DeleteLink: DefaultUrl,
	Height: DefaultText,
	Id: DefaultText,
	Image: DefaultPicture,
	ImageSrc: DefaultText,
	PetLink: DefaultUrl,
	Position: false,
	Width: DefaultText,
};

export const DefaultTeam: MiaPlaza.Control.Vue.Lists.ITeam = {
	IsNew: false,
	NumberOfUsers: 0,
	TeamName: DefaultText,
	TeamUrl: DefaultUrl,
};

export const DefaultTestimonial: MiaPlaza.LO.Testimonials.ITestimonial = {
	Author: DefaultText,
	Highlight: DefaultText,
	Text: DefaultText,
};

export const DefaultMohsStudentFilter: MiaPlaza.LO.Mohs.Models.IMohsStudentFilter = {
	IsActive: null,
	SortByDateOfLastCompletedTaskAscending: null
};

export const DefaultTransaction: MiaPlaza.Control.Vue.Lists.ITransaction = {
	Picture: DefaultPicture,
	Text: DefaultText,
	Time: DefaultTime,
};

export const DefaultFAQCategory: MiaPlaza.ConfigModel.FAQ.IFAQCategory = {
	Category: DefaultText,
	AnsweredQuestions: [],
};

export const DefaultAnsweredQuestion: MiaPlaza.ConfigModel.FAQ.IAnsweredQuestion = {
	Answer: DefaultText,
	Question: DefaultText,
};

export const DefaultAssessmentQuestion: MiaPlaza.Control.Vue.Lists.IQuestion = {
	Answers: [],
	Image: DefaultPicture,
	Text: [],
	AnswerStatus: MiaPlaza.Model.PremiumParent.Status.NoAnswer,
	IsFreeInputQuestion: true
};

export const DefaultAdminTextResource: MiaPlaza.Control.Vue.Lists.IAdminTextResource = {
	Data: [],
	DeleteUrl: DefaultUrl,
	EditUrl: DefaultUrl,
	Extra: [],
	Key: DefaultText,
	SupportedApplications: [],
	SupportedPortals: [],
};

export const DefaultDesignedItem: MiaPlaza.Control.Vue.Lists.IDesignedItem = {
	Id: 0,
	Image: DefaultPicture,
	SelectedItemModule: DefaultText,
};

export const DefaultDesignTemplate: MiaPlaza.Controllers.Shop.IDesignTemplateData = {
	Thumbnail: DefaultPicture,
	Price: 0,
	Url: DefaultUrl
};

export const DefaultNewspaperArticle: MiaPlaza.Control.Vue.Lists.INewspaperArticle = {
	Body: DefaultText,
	ClickUrl: DefaultUrl,
	CreationDate: DefaultText,
	LinkText: DefaultText,
	Title: DefaultText,
};

export const DefaultCourseReport: MiaPlaza.LO.Curriculum.Display.ICourseReport = {
	Assessments: [],
	StudyTime: DefaultText,
	Subject: DefaultSubject,
	Course: DefaultText,
	Title: DefaultText,
	OverallScore: DefaultText,
	SelectedDatesScore: DefaultText
};

export const DefaultMiniWorldDraft: MiaPlaza.Controllers.Shop.IMiniWorldDraft = {
	RedirectLink: DefaultUrl,
	MiniworldDraft: DefaultText,
	Image: DefaultText,
	Name: DefaultText,
};

export const DefaultAttendanceReportEntry: MiaPlaza.LO.Attendance.Dtos.IAttendanceReportEntry = {
	DayAttendanceReports: [],
	Title: DefaultText,
	TotalTime: DefaultTime
};

export const DefaultNewsletterContent: MiaPlaza.Control.Vue.Lists.INewsletterContent = {
	Action: MiaPlaza.Control.Vue.Lists.NewsletterAction.None,
	ActionLink: DefaultUrl,
	CreationDate: DefaultTime,
	DeleteLink: DefaultUrl,
	DuplicateLink: DefaultUrl,
	OpenLabel: DefaultText,
	OpenLink: DefaultText,
	Progress: DefaultText,
	Status: DefaultText,
	Subject: DefaultText,
	Newsletter: DefaultText,
	ShownOnParentPortal: false,
};

export const DefaultUploadedImage: MiaPlaza.Control.Vue.Lists.IUploadedImage = {
	CreationDateAndTime: DefaultText,
	DeleteLink: DefaultUrl,
	Id: 0,
	PathOnDisk: DefaultText,
	PathOnWebsite: DefaultText,
};

export const DefaultLostPet: MiaPlaza.Control.Vue.Lists.ILostPet = {
	GiveBackLink: DefaultUrl,
	OwnerId: 0,
	OwnerName: DefaultText,
	PetName: DefaultText,
	PetPicture: DefaultPicture,
};

export const DefaultProgressStatistics: MiaPlaza.LO.Assessment.IProgressStatistics = {
	Answered: 0,
	AnsweredPercentage: 0,
	Correct: 0,
	CorrectPercentage: 0,
	Total: 0,
	Wrong: 0,
	IsAssessmentPassed: true,
};

export const DefaultLessonAssessment: MiaPlaza.Controllers.Curriculum.LessonView.IAssessmentData = {
	Component: "lesson-content-assessment",
	Lesson: DefaultUrl,
	Flavor: MiaPlaza.Model.Curriculum.Task.Flavor.Assessment,
	IsAssigned: false,
	IsExcused: false,
	IsCompleted: false,
	IsLocked: true,
	Name: DefaultText,
	Score: null,
	ThumbnailBackground: DefaultPicture,
};

export const DefaultLessonVideo: MiaPlaza.Controllers.Curriculum.LessonView.IVideoData = {
	Component: "lesson-content-video",
	ContentLink: DefaultUrl,
	Flavor: MiaPlaza.Model.Curriculum.Task.Flavor.Teaching,
	IsAssigned: false,
	IsExcused: false,
	IsCompleted: false,
	IsLocked: true,
	Name: DefaultText,
	Thumbnail: DefaultPicture,
};

export const DefaultLessonPractice: MiaPlaza.Controllers.Curriculum.LessonView.IPracticeData = {
	Component: "lesson-content-supplemental",
	Lesson: DefaultUrl,
	Flavor: MiaPlaza.Model.Curriculum.Task.Flavor.Activity,
	IsAssigned: false,
	IsExcused: false,
	IsCompleted: false,
	IsLocked: true,
	Medal: DefaultPicture,
	Name: DefaultText,
	Thumbnail: DefaultPicture,
};

export const DefaultAdminSubscriptionEmbedded: MiaPlaza.Control.Vue.Lists.IAdminSubscriptionEmbedded = {
	Canceled: false,
	Creation: DefaultText,
	ExternalId: DefaultText,
	FutureStartDate: false,
	PastDue: false,
	PausedUntil: DefaultText,
	Product: DefaultText,
	Start: DefaultText,
	SyncUrl: DefaultText,
	Type: DefaultText,
	UnpauseUrl: DefaultText,
};

export const DefaultAdminCustomGameVersion: MiaPlaza.Controllers.Admin.ICustomGameVersion = {
	Number: 0,
	Text: DefaultText
};

export const DefaultAdminCustomGame: MiaPlaza.Controllers.Admin.ICustomGame = {
	AssessmentLink: DefaultUrl,
	CommonIdentifier: DefaultText,
	LocalVersion: DefaultAdminCustomGameVersion,
	RemoteVersion: DefaultAdminCustomGameVersion,
	IsInstalled: true,
	LessonLink: DefaultUrl,
	PracticeLink: DefaultUrl,
};

export const DefaultAdminProductPrice: MiaPlaza.Controllers.Admin.IAdminProductPrice = {
	End: DefaultText,
	FirstPeriodPrice: 0,
	Price: 0,
	Product: DefaultText,
	Start: DefaultText,
};


export const DefaultTaskData: MiaPlaza.Controllers.Curriculum.ILearningPathTaskData = {
	Description: DefaultText,
	Icon: DefaultPicture,
	Link: DefaultUrl,
	Thumbnail: DefaultPicture,
	ThumbnailTitle: DefaultText,
	TaskType: MiaPlaza.LO.Lesson.Dtos.Tasks.TaskType.Assessment,
	ScheduledForToday: true,
	CheckpointAssessment: false
};

export const DefaultCourseData: MiaPlaza.Controllers.Curriculum.ICourseData = {
	Title: DefaultText,
};

export const DefaultAssignedCourseData: MiaPlaza.Controllers.Curriculum.IAssignedCourseData = {
	...DefaultCourseData,
	LearningPathTask: DefaultTaskData,
	State: MiaPlaza.LO.CourseState.None,
};

export const DefaultCurriculumCourse: MiaPlaza.Controllers.Curriculum.Configuration.ICourseData = {
	Title: DefaultText,
	Description: DefaultText,
	RecommendedGradeMin: MiaPlaza.Model.Grades.Grade.Seventh,
	RecommendedGradeMax: MiaPlaza.Model.Grades.Grade.Eighth,
	RecommendedLength: 0,
	RecommendedSchoolWeekLength: 0,
	Enrolled: false,
	EnrollmentStatus: MiaPlaza.LO.Curriculum.Configuration.CourseEnrollmentStatus.InProgress,
	InDevelopment: false,
	Credits: 0,
};

export const DefaultLessonPdfData: MiaPlaza.Controllers.Curriculum.Configuration.ILessonPdfData = {
	LessonTitle: DefaultText,
	PDFs: []
};

export const DefaultCurriculumUnit: MiaPlaza.Controllers.Curriculum.Configuration.IUnitData = {
	Title: DefaultText,
	LessonPdfs: []
};

export const DefaultCurriculumLesson: MiaPlaza.Controllers.Curriculum.Configuration.ILessonData = {
	Name: DefaultText,
	Progress: null,
	IsTextToSpeechEnabled: false,
	CheckpointAssessmentInLesson: false,
	IsExcused: false
};

export const DefaultPublicHoliday: MiaPlaza.Controllers.Curriculum.Configuration.IPublicHolidayData = {
	Date: DefaultTime,
	Observed: false,
	Selected: false,
};

export const DefaultCustomBreak: MiaPlaza.Controllers.Curriculum.Configuration.ICustomBreakData = {
	Name: DefaultText,
	Start: DefaultTime,
	End: DefaultTime,
};

export const DefaultSupplementalMaterial: MiaPlaza.Controllers.Curriculum.LessonView.ISupplementalMaterialData = {
	Component: "lesson-content-supplemental",
	ContentLink: DefaultUrl,
	Flavor: MiaPlaza.Model.Curriculum.Task.Flavor.Activity,
	Icon: DefaultPicture,
	IsAssigned: false,
	IsExcused: false,
	IsCompleted: false,
	IsLocked: true,
	Name: DefaultText,
	SupplementalMaterialType: MiaPlaza.Model.Games.SupplementalMaterialType.EmbeddedURL,
	ThumbnailBackground: DefaultPicture,
	CheckpointAssessment: false
};

export const DefaultLessonFlavor: MiaPlaza.Controllers.Curriculum.LessonView.ILessonFlavorData = {
	Icon: DefaultPicture,
	IsAssigned: false,
	IsCompleted: false,
	IsLocked: false,
	AssignedElementIndex: 0,
	CheckpointAssessmentInFlavor: false
};

export const DefaultScheduleDay: MiaPlaza.Controllers.Curriculum.Schedule.IDayData = {};

export const DefaultConfigureCurriculumSubject: MiaPlaza.Model.Subject = DefaultSubject;

export const DefaultScheduleUnit: MiaPlaza.Controllers.Curriculum.Schedule.IUnitData = {
	Subject: DefaultSubject,
	Title: DefaultText,
	CourseTitle: DefaultText,
};

export const DefaultScheduleTask: MiaPlaza.LO.Curriculum.Display.ITaskAssignmentData = {
	Image: DefaultPicture,
	Name: DefaultText,
	Status: MiaPlaza.Controllers.Curriculum.Enums.ProgressStatus.None,
	Type: MiaPlaza.LO.Lesson.Dtos.Tasks.TaskType.Assessment,
	PreviewData: {
		Title: DefaultText,
	},
	Icon: DefaultPicture,
	CheckpointAssessment: false,
};

export const DefaultSearchScheduleTask: MiaPlaza.Controllers.Curriculum.Schedule.ISearchTaskAssignmentData = {
	...DefaultScheduleTask,
	ScheduledDate: DefaultDateString,
	Unit: DefaultText,
	Subject: DefaultSubject,
};

export const DefaultArcadeGame: MiaPlaza.Control.Vue.Lists.IArcadeGame = {
	Name: DefaultText,
	Thumbnail: DefaultPicture,
	Url: DefaultUrl,
};

export const DefaultTopEarner: MiaPlaza.Controllers.Admin.ITopEarner = {
	ChildName: DefaultText,
	ChildProfileLink: DefaultText,
	VirtualMoney: 0,
	EarningsOverPeriod: 0,
	Child: DefaultText,
	CheaterStatus: MiaPlaza.Model.CheaterStatus.None
};

export const DefaultCompetitionWinner: MiaPlaza.Controllers.Admin.ICompetitionWinner = {
	Name: DefaultText,
	ProfileLink: DefaultText,
	CompetitionDate: DefaultDateString,
	CompetitionType: MiaPlaza.Model.CompetitionType.MostVirtualCurrencyEarned,
	MoneyEarned: 0,
	PrizeName: DefaultText
}

export const DefaultCompetitionLeader: MiaPlaza.Controllers.Admin.ICompetitionLeader = {
	Name: DefaultText,
	ProfileLink: DefaultText,
	MoneyEarned: 0
}

export const DefaultQuizAssessmentAttempt: MiaPlaza.Controllers.Gradebook.IQuizAssessmentAttempt = {
	Finished: DefaultTime,
	Score: 0,
	Passed: true
};

export const DefaultActiveModerator: MiaPlaza.Controllers.Admin.IActiveModerator = {
	Name: DefaultText,
	Moderator: DefaultText,
	NumberOfLocks: 0
};

export const DefaultMohsChildData: MiaPlaza.LO.PlusAndMohs.Models.IChildData = {
	Name: DefaultText,
	Id: null,
	UUId: DefaultText,
};

export const DefaultAssessmentAttemptNotificationSettings: MiaPlaza.LO.Assessment.IAssessmentAttemptNotificationSettings = {
	MaxAssessmentAttemptAmount: 0,
	Enabled: false
};

export const DefaultMohsStudentInformation: MiaPlaza.LO.Mohs.Models.IMohsStudentInformation = {
	Child: DefaultMohsChildData,
	SapLink: null,
	EMail: null
};

export const DefaultMohsParentData: MiaPlaza.LO.PlusAndMohs.Models.IParentData = {
	Name: DefaultText,
	Url: DefaultUrl
};

export const DefaultMohsStudent: MiaPlaza.Controllers.Admin.Mohs.IMohsStudent = {
	ChildData: DefaultMohsChildData,
	ParentData: DefaultMohsParentData,
	NumberOfUngradedOrMissingCheckpoints: 0,
	DateOfLastCompletedTask: DefaultDateString,
	SapLink: DefaultText,
	IsActive: false,
	EMail: DefaultText,
	UUId: DefaultText
};

export const DefaultPlusStudent: MiaPlaza.Controllers.Admin.Plus.IPlusStudent = {
	ChildData: DefaultMohsChildData,
	ParentData: DefaultMohsParentData,
	NumberOfUngradedOrMissingCheckpoints: 0,
	DateOfLastCompletedTask: DefaultDateString
};

export const DefaultLessonFeedback: MiaPlaza.Controllers.Admin.LessonFeedback.ILessonFeedback = {
	StudentId: 0,
	SubmitDate: DefaultLocalDateTime,
	Course: DefaultText,
	Unit: DefaultText,
	Lesson: DefaultText,
	TaskType: MiaPlaza.LO.Lesson.Dtos.Tasks.TaskType.Practice,
	MinLevel: 0,
	MaxLevel: 0,
	Difficulty: 0,
	Enjoyment: 0,
	AdditionalFeedback: DefaultText
};

export const DefaultPaymentData = {
	ParentName: DefaultText,
	ParentEmail: DefaultText,
	PaymentDate: DefaultDateString,
	StudentName: DefaultText,
	Amount: 0,
	Product: MiaPlaza.Model.Payments.ProductType.OneMonth,
	PaymentMethodData: {
		Description: DefaultText,
		PaymentMethodType: DefaultText,
	} as MiaPlaza.LO.Payments.Display.IPaymentMethodData,
};

export const DefaultVocabularyQuestion: MiaPlaza.Controllers.Curriculum.Configuration.IVocabularyQuestion = {
	Word: DefaultText,
	Meaning: DefaultText
};

export const DefaultVirtualCurrencyTransaction: MiaPlaza.Controllers.Admin.IVirtualCurrencyTransaction = {
	Reason: DefaultText,
	Type: DefaultText,
	PreviousAmount: 0,
	Delta: 0,
	DateTime: DefaultLocalDateTime
};

export const DefaultAdminCouponCode: MiaPlaza.Control.Vue.Lists.IAdminCouponCode = {
	Code: DefaultText,
	CouponCodeDiscounts: [],
	Expiration: DefaultDateString,
	IsUsed: true,
	UUId: DefaultText,
	Notes: DefaultText,
	SelectedItemModule: DefaultText,
	VisitorCount: 0,
};

export const DefaultUploaderData: MiaPlaza.Controllers.Video.IUploaderData = {
	Author: DefaultText,
	AuthorAvatar: DefaultPicture,
	MemberUrl: DefaultUrl
}

export const DefaultVideoData: MiaPlaza.Controllers.Video.IVideoData = {
	Uploader: DefaultUploaderData,
	AvailableSince: DefaultInstantString,
	Thumbnail: DefaultPicture,
	VideoUrl: DefaultUrl,
	Title: DefaultText,
	Duration: DefaultDuration,
	IsNew: false
};

export const DefaultVideoSetting: MiaPlaza.ConfigModel.Video.IVideoSetting = {
	Url: DefaultUrl,
	Title: DefaultText
};

export const DefaultFilmmaker: MiaPlaza.Controllers.Video.IFilmmakerData = {
	Name: DefaultText,
	Avatar: DefaultPicture,
	ProfileUrl: DefaultUrl
};

export const DefaultBuyerData: MiaPlaza.Controllers.Admin.IBuyerData = {
	Id: 0,
	AccountLink: DefaultUrl,
	Firstname: DefaultText,
	Lastname: DefaultText,
	EMail: DefaultText,
	NumberOfChildren: 0,
	ChildrenLogins: 0,
	PurchaseStatistics: DefaultPurchaseStatistics,
};

export const DefaultUnitData: MiaPlaza.Controllers.Lessons.IUnitData = {
	Title: DefaultText,
	CourseTitle: DefaultText,
	IsExcused: false
};

export const DefaultLessonData: MiaPlaza.Controllers.Lessons.ILessonData = {
	Name: DefaultText,
	Image: DefaultPicture,
	Link: DefaultUrl,
	HighestMedal: MiaPlaza.Model.Games.MedalType.None,
	Subject: DefaultSubject,
	CheckpointAssessmentInLesson: false,
	IsExcused: false
}

export const DefaultShoutboxLine: MiaPlaza.Controllers.ShoutBox.IShoutboxLineData = {
	ShoutboxLine: DefaultText,
	Author: DefaultText,
	Text: DefaultText,
	ProfileImage: DefaultPicture,
	ProfileLink: DefaultUrl,
	CreationDate: DefaultDateString,
	CanPublish: false,
	CanDelete: false
};

export const DefaultTeamMember: MiaPlaza.Control.Vue.ITeamMember = {
	Title: DefaultText,
	About: DefaultText,
	PictureUrl: DefaultText,
};

export const DefaultCourseGrade: MiaPlaza.LO.Curriculum.ICourseGrade = {
	AssessmentAverage: 0,
	CheckpointAverage: 0,
	OverallScoreText: DefaultText
}

export const DefaultCourseProgress: MiaPlaza.LO.Curriculum.ICourseProgress = {
	Actual: 0,
	Expected: 0,
	Behind: false
}

export const DefaultGradebookCourse: MiaPlaza.Controllers.Gradebook.IGradebookCourse = {
	Course: DefaultText,
	Subject: DefaultSubject,
	Title: DefaultText,
	NonZeroGradedCheckpoints: 0,
	TotalCheckpoints: 0,
	InDevelopment: false,
	Grade: DefaultCourseGrade,
	StartDate: DefaultDateString,
	EndDate: DefaultDateString,
	Progress: DefaultCourseProgress,
	CompletedUngradedCheckpoints: 0,
	Credits: 0
};

export const DefaultGradebookAssignment: MiaPlaza.Controllers.Gradebook.IGradebookAssignment = {
	Title: DefaultText,
	BestAttemptUUId: DefaultText,
	IsConsideredPassed: false,
	IsAssessment: true,
	IsExcused: false,
	IsMissing: false,
	HasPassingGrade: false,
	TaskCompleted: false,
	Completion: DefaultDateString,
	Grade: null,
	Attempts: 0,
	Course: DefaultText
};

export const DefaultCourseEnrollment: MiaPlaza.Controllers.Curriculum.Configuration.ICourseEnrollmentData = {
	Title: DefaultText,
	Course: DefaultText,
	UUId: DefaultText,
	Status: MiaPlaza.LO.Curriculum.Configuration.CourseEnrollmentStatus.InProgress,
	Start: DefaultText,
	End: DefaultText,
	SchoolWeek: [],
	InDevelopment: false,
	PdfUrl: DefaultText,
	WorkbookUrl: DefaultText
};

export const DefaultUserData: MiaPlaza.Control.Vue.IUserData = {
	FirstName: DefaultText,
	LastName: DefaultText,
	Email: DefaultText,
}

export const DefaultReportTask: MiaPlaza.LO.Curriculum.Display.IAssessmentData = {
	Name: DefaultText,
	Progress: DefaultText,
	Instant: DefaultDateString,
	Date: DefaultLocalDateTime,
	DetailsLink: DefaultUrl,
	IncludeInPrintableReport: false,
	UUId: DefaultText,
	CheckpointAssessment: false,
	IsExcused: false
}

export const DefaultHouse: MiaPlaza.Controllers.MiniWorld.IHouse = {
	ChildName: DefaultText,
	ChildProfileLink: DefaultUrl,
	MiniWorldHouseLink: DefaultUrl,
	ChildAvatar: DefaultPicture,
	Castle: DefaultPicture,
}

export const DefaultTeamAchievements: MiaPlaza.Controllers.TeamAchievements.ITeamAchievements = {
	TeamName: DefaultText,
	TeamProfileLink: DefaultText,
	GoldMedals: 0,
	SilverMedals: 0,
	BronzeMedals: 0
}

export const DefaultCourseEnrollmentShift: MiaPlaza.LO.Curriculum.Configuration.ICourseEnrollmentShift = {
	Title: DefaultText,
	CurrentInterval: [DefaultLocalDateTime, DefaultLocalDateTime],
	AdjustedInterval: [DefaultLocalDateTime, DefaultLocalDateTime],
	CourseEnrollment: DefaultText,
}
export const DefaultTutorialVideo: MiaPlaza.ConfigModel.Video.IVideoSetting = {
	Title: DefaultText,
	Url: DefaultUrl
}

export const DefaultListItem: MiaPlaza.Controllers.RankedList.IListItem = {
	MemberName: DefaultText,
	MemberUrl: DefaultUrl,
	IsCurrentMember: false,
	Value: DefaultText
}

export const DefaultSpecialUser: MiaPlaza.Controllers.Admin.ISpecialUserData = {
	ProfileLink: DefaultUrl,
	FirstAndLastName: DefaultText,
	SpecialUserType: MiaPlaza.Model.SpecialUserType.DEFAULT_MEMBER,
	EMail: DefaultText
}

export const DefaultAudioSettings: MiaPlaza.LO.Games.IAudioSettings = {
	FeedbackSoundAvailableInGame: false,
	FeedbackSoundEnabled: false,
	TextToSpeechAvailableInGame: false,
	TextToSpeechEnabledByParent: false,
	TextToSpeechEnabled: false
};

export const DefaultLessonTask: MiaPlaza.LO.Lesson.Dtos.Tasks.ITask = {
	Id: DefaultText,
	Type: MiaPlaza.LO.Lesson.Dtos.Tasks.TaskType.Practice,
	Assigned: true,
	Completed: false,
	ShouldAskForFeedback: false
}
export const DefaultUserUploadedVideo: MiaPlaza.Controllers.Moderation.IUserUploadedVideo = {
	Name: DefaultText,
	HintsForModerator: DefaultText,
	UploadDate: DefaultDateString,
	UploaderName: DefaultText,
	UploaderProfileUrl: DefaultUrl,
	VideoUrl: DefaultUrl,
	ModerationApproval: MiaPlaza.Model.UserUploadedContent.ApprovalLevel.NotDecided,
	ParentApproval: MiaPlaza.Model.UserUploadedContent.ApprovalLevel.NotDecided,
	Thumbnail: DefaultPicture,
	ApprovedByChild: true,
	ModerationStatusTextResourceKey: DefaultText,
	ModerationApprovalComment: DefaultText,
	ModerationMessageForParents: DefaultText,
	ModerationRejectionReason: DefaultText,
	ModeratorRating: MiaPlaza.Model.UserUploadedContent.ModerationRating.Good,
	IsEducational: false
};

const DefaultChildPenaltyReason: MiaPlaza.LO.Moderation.ChildPenaltyReasons.IChildPenaltyReason = {
	PenaltyType: MiaPlaza.LO.Moderation.Enums.ChildPenaltyType.Simple
}

export const DefaultChildPenaltyItem: MiaPlaza.Controllers.Admin.Moderation.IChildPenaltyItem = {
	PenaltyType: DefaultText,
	IsActive: true,
	CreationDate: DefaultDateString,
	Until: DefaultDateString,
	Reason: DefaultChildPenaltyReason,
	ChildPenalty: DefaultText
};

export const DefaultLessonTaskData: MiaPlaza.Controllers.Curriculum.Configuration.ITaskData = {
	Name: DefaultText,
	TaskType: MiaPlaza.LO.Lesson.Dtos.Tasks.TaskType.Practice,
	PreviewData: { Title: DefaultText },
	Progress: DefaultText,
	CheckpointAssessment: false,
	IsExcused: false
}

export const DefaultShopCompetitionItem: MiaPlaza.Controllers.Shop.IShopWithCustomers = {
	Name: DefaultText,
	Avatar: DefaultPicture,
	ProfileUrl: DefaultUrl,
	ShopUrl: DefaultUrl,
	HouseUrl: DefaultUrl,
	NumberOfCustomers: 0
}
